import React, { useState } from "react";
import { apiClient } from "../../lib/api";
import { toast } from "sonner";
import { Copy, FileSignature, CheckCircle2 } from "lucide-react";

const C = { forest: "#2B4C3B", ink: "#0F172A", dim: "#475569", line: "#E2E0D8" };

export default function TPApprovedDialog({ data, onClose }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const copy = (text) => navigator.clipboard?.writeText(text).then(() => toast.success("Copied"));

  const sendContract = async () => {
    setSending(true);
    try {
      await apiClient.post(`/tpt/providers/${data.tp_id}/contract/send-link`);
      setSent(true);
      toast.success("Contract link sent");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not send contract");
    } finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(15,23,42,0.55)" }} data-testid="tp-approved-dialog">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl space-y-4">
        <div className="flex items-center gap-2 text-lg font-bold" style={{ color: C.ink }}>
          <CheckCircle2 size={20} color={C.forest} /> {data.tp_name} approved
        </div>
        <div className="rounded-xl p-3 text-sm space-y-1" style={{ background: "#F8F7F2" }}>
          <div style={{ color: C.dim }}>Portal: <b style={{ color: C.ink }}>{data.portal_url}</b></div>
          <div style={{ color: C.dim }}>Login email: <b style={{ color: C.ink }}>{data.dispatcher_email || "—"}</b></div>
          {data.temp_password ? (
            <div className="flex items-center gap-2" style={{ color: C.dim }}>
              Temporary password: <b data-testid="tp-approved-temp-password" style={{ color: C.ink, fontFamily: "monospace" }}>{data.temp_password}</b>
              <button onClick={() => copy(data.temp_password)} data-testid="tp-approved-copy-btn" className="p-1 rounded hover:bg-white"><Copy size={14} /></button>
            </div>
          ) : (
            <div className="text-xs" style={{ color: C.dim }}>This email already had a portal login, so no new password was created. Use "Resend portal login" on the Floor if they need a fresh one.</div>
          )}
          <div className="text-xs pt-1" style={{ color: C.dim }}>This was also emailed to the provider. It is shown only once.</div>
        </div>
        <button onClick={sendContract} disabled={sending || sent} data-testid="tp-approved-send-contract-btn"
          className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-bold text-white disabled:opacity-60" style={{ background: C.forest }}>
          <FileSignature size={15} /> {sent ? "Contract sent" : sending ? "Sending…" : "Send contract now"}
        </button>
        <button onClick={onClose} data-testid="tp-approved-continue-btn"
          className="w-full py-2.5 rounded-lg text-sm font-semibold border" style={{ borderColor: C.line, color: C.ink }}>
          Continue to fill in missing details →
        </button>
      </div>
    </div>
  );
}
